"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _dsIcons = require("@olxbr/ds-icons");
var _adsDeletionModalWeb = require("@olxbr/ads-deletion-modal-web");
var _selectors = require("../../../selectors");
var _TipBox = _interopRequireDefault(require("../TipBox"));
var _actions = require("../../../actions");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["listId", "subject", "tipType"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var getAlreadyTipText = {
  text: 'Já vendeu este anúncio? Marque como vendido! Todos os chats relacionados se tornarão inativos e você para de receber novos contatos sobre ele.',
  // eslint-disable-line max-len
  cta: 'Marcar como vendido'
};
var AlreadySoldTip = function AlreadySoldTip(_ref) {
  var listId = _ref.listId,
    subject = _ref.subject,
    _ref$tipType = _ref.tipType,
    tipType = _ref$tipType === void 0 ? 'already_sold_tip' : _ref$tipType,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var eliminatorRef = /*#__PURE__*/_react["default"].createRef();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], _objectSpread({
      tip: {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.ThumbsUp, {}),
        text: getAlreadyTipText.text,
        links: {
          web: function web() {
            return eliminatorRef.current.handleOpenModal();
          }
        },
        cta: getAlreadyTipText.cta
      },
      type: tipType,
      variant: "information"
    }, otherProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_adsDeletionModalWeb.Eliminator, {
      ref: eliminatorRef,
      title: subject,
      listId: listId,
      onCloseModal: function onCloseModal() {},
      onAdDeletedSuccess: function onAdDeletedSuccess() {}
    })]
  });
};
AlreadySoldTip.propTypes = {
  listId: _propTypes.string.isRequired,
  subject: _propTypes.string.isRequired,
  tipType: _propTypes.string
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var chat = (0, _selectors.getChatByRoomName)(state, ownProps.roomname);
  return {
    subject: chat.subject
  };
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps)(AlreadySoldTip);